import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de7c2662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TestResultGrid" }
const _hoisted_2 = { class: "AnalysesTitles" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ListHead" }, null, -1))
const _hoisted_4 = { class: "List" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestResultGridSampleColumn = _resolveComponent("TestResultGridSampleColumn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkedSamples, (subList, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "Grid"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cleanAnalysisTestsAsArray, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ListCell IsFirstColumn",
                key: item.id
              }, _toDisplayString(_ctx.mixWB(item.translation)), 1))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subList, (sample, sampleIndex) => {
          return (_openBlock(), _createBlock(_component_TestResultGridSampleColumn, {
            key: sample.id,
            disableLink: _ctx.disableLink,
            sample: sample,
            isLastColumn: subList.length - 1 === sampleIndex
          }, null, 8, ["disableLink", "sample", "isLastColumn"]))
        }), 128))
      ]))
    }), 128))
  ]))
}